import React from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import PDF from "./../../../assets/svg/pdf.svg";
import { BsFillChatDotsFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
let Result = () => {
  const navigate = useNavigate();
  let TableData = [
    {
      date: "Jan 04, 2022",
      subject: "Maths",
      studentName: "Willow Anderson, John smith, David... ",
      class: "Class 5th A",
      taskName: "Fusce tincidunt ante ex, quis ...",
      remarks: "ante ex, quis ...",
    },
    {
      date: "Jan 04, 2022",
      subject: "Maths",
      studentName: "Willow Anderson, John smith, David... ",
      class: "Class 5th A",
      taskName: "Fusce tincidunt ante ex, quis ...",
      remarks: "ante ex, quis ...",
    },

    {
      date: "Jan 04, 2022",
      subject: "Maths",
      studentName: "Willow Anderson, John smith, David... ",
      class: "Class 5th A",
      taskName: "Fusce tincidunt ante ex, quis ...",
      remarks: "ante ex, quis ...",
    },
    {
      date: "Jan 04, 2022",
      subject: "Maths",
      studentName: "Willow Anderson, John smith, David... ",
      class: "Class 5th A",
      taskName: "Fusce tincidunt ante ex, quis ...",
      remarks: "ante ex, quis ...",
    },
    {
      date: "Jan 04, 2022",
      subject: "Maths",
      studentName: "Willow Anderson, John smith, David... ",
      class: "Class 5th A",
      taskName: "Fusce tincidunt ante ex, quis ...",
      remarks: "ante ex, quis ...",
    },
    {
      date: "Jan 04, 2022",
      subject: "Maths",
      studentName: "Willow Anderson, John smith, David... ",
      class: "Class 5th A",
      taskName: "Fusce tincidunt ante ex, quis ...",
      remarks: "ante ex, quis ...",
    },

    {
      date: "Jan 04, 2022",
      subject: "Maths",
      studentName: "Willow Anderson, John smith, David... ",
      class: "Class 5th A",
      taskName: "Fusce tincidunt ante ex, quis ...",
      remarks: "ante ex, quis ...",
    },
    {
      date: "Jan 04, 2022",
      subject: "Maths",
      studentName: "Willow Anderson, John smith, David... ",
      class: "Class 5th A",
      taskName: "Fusce tincidunt ante ex, quis ...",
      remarks: "ante ex, quis ...",
    },
    {
      date: "Jan 04, 2022",
      subject: "Maths",
      studentName: "Willow Anderson, John smith, David... ",
      class: "Class 5th A",
      taskName: "Fusce tincidunt ante ex, quis ...",
      remarks: "ante ex, quis ...",
    },
  ];
  return (
    <SideMenu>
      <div className="page-container">
        <div>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={10} lg={10} md={10} sm={8} xs={8}></Grid>
              <Grid item xl={2} lg={2} md={2} sm={4} xs={4}>
                <Button className="header-button" variant="text">
                  <p className="page-header-button-text">Download</p>
                </Button>
              </Grid>
              <Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
                <div>
                  <p className="header-input-heading">Subject Name</p>
                  <input
                    type="text"
                    className="header-input"
                    placeholder="Subject Name"
                  />
                </div>
              </Grid>
              <Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
                <div>
                  <p className="header-input-heading">Student Name</p>
                  <input
                    type="text"
                    className="header-input"
                    placeholder="Student Name"
                  />
                </div>
              </Grid>
              <Grid item xl={2} lg={2} md={3} sm={3} xs={6}>
                <div>
                  <p className="header-input-heading">Class</p>
                  <input
                    type="text"
                    className="header-input"
                    placeholder="Class"
                  />
                </div>
              </Grid>
              <Grid item xl={2} lg={2} md={3} sm={3} xs={6}>
                <div>
                  <p className="header-input-heading">Class Division</p>
                  <input
                    type="text"
                    className="header-input"
                    placeholder="Class Division"
                  />
                </div>
              </Grid>
              <Grid item xl={2} lg={2} md={3} sm={3} xs={12}>
                <div>
                  <p className="header-input-heading">Task name</p>
                  <input
                    type="text"
                    className="header-input"
                    placeholder="Task name"
                  />
                </div>
              </Grid>
              <Grid item xl={4} lg={4} md={7} sm={6} xs={12}>
                <DateRangePicker />
              </Grid>
              <Grid item xl={2} lg={2} md={2} sm={3} xs={12}>
                <div>
                  <Button className="header-apply-button" variant="text">
                    <p className="header-apply-button-text">Apply</p>
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Box>
          <br />
          <br />
          <div className="table-container">
            <div className="table-header">
              <p className="table-heading">result</p>
            </div>
            <div className="table-data-container">
              <table>
                <thead>
                <tr>
                  <th className="result-table-id-heading">ID</th>
                  <th className="result-table-date-heading">Date</th>
                  <th className="result-table-subject-name-heading">
                    Subject Name
                  </th>
                  <th className="result-table-student-name-heading">
                    Student Name
                  </th>
                  <th className="result-table-class-and-devision-heading">
                    Class and Division
                  </th>
                  <th className="result-table-task-name-heading">Task name</th>
                  <th className="result-table-task-attachment-heading">
                    Attachment
                  </th>
                  <th className="result-table-remarks-heading">Remarks</th>
                  <th className="result-table-chat-heading"></th>
                  <th className="result-table-view-task-heading"></th>
                </tr>
                </thead>
                {TableData.map((tableValue, tableIndex) => {
                  return (
                    <tr id={tableIndex}>
                      <td className="table-id-data">{tableIndex + 1}</td>
                      <td className="table-data">{tableValue.date}</td>
                      <td className="table-data">{tableValue.subject}</td>
                      <td className="table-data">{tableValue.studentName}</td>
                      <td className="table-center-data">{tableValue.class}</td>
                      <td className="table-data">{tableValue.taskName}</td>
                      <td className="table-data">
                        <div class="result-table-pdf-button-main">
                          <Button>
                            <img src={PDF} />
                          </Button>
                        </div>
                      </td>
                      <td className="table-data">{tableValue.remarks}</td>
                      <td className="table-data">
                        <Button onClick={() => navigate("/tutor-panel/chat")}>
                          <BsFillChatDotsFill color="#663399" size={20} />
                        </Button>
                      </td>
                      <td
                        className="table-data"
                        onClick={() => navigate("/tutor-panel/result/view")}
                      >
                        <Button className="result-table-view-task-button">
                          View result
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default Result;
